import { Logo } from 'shared/assets/images'

export const RightSection = () => {
    return (
        <div className="hidden h-screen flex-grow items-center justify-center overflow-hidden bg-background-primary lg:flex lg:w-[50%]">
            <img className="h-full w-full object-cover" src={Logo} alt="logo" />
        </div>
    )
}
